import React from "react";
import * as ROUTES from "../../Router/venue_routes";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import { ButtonPrimary } from "../Button";

const HotelGroupsList = ({
  hotelGroups,
  isFetchingHotelGroups,
  isHotelGroupUser,
  isHotelGroupAdmin,
  isRolePlatformAdmin,
}) => {
  return (
    <table className="edge-table">
      <thead>
        <tr>
          <th width={'40%'}>Name</th>
          <th width={'40%'}>Parent Group</th>
          <th width={'10%'}>Group Type</th>
          <th width={'10%'}>Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
      {isFetchingHotelGroups  ? (
        <tr><td colSpan={4}><Loading /></td></tr>
      ) : null }
      { hotelGroups.length > 0 &&
          hotelGroups.map(hotelGroup => {
            return (
              <tr key={hotelGroup.id}>
                <td>
                  <div className="flex items-center">
                    <Link
                      to={
                        isHotelGroupUser
                          ? ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_VIEW.replace(
                            ":id",
                            hotelGroup.id
                          )
                          : ROUTES.FRONTEND.HOTEL_GROUPS.SINGLE_VIEW.replace(
                            ":id",
                            hotelGroup.id
                          )
                      }
                      className={"text-black"}
                    >
                      {hotelGroup?.name}
                      {isRolePlatformAdmin && !hotelGroup?.is_visible ?
                        <i className="fal fa-eye-slash text-warning pl-2"></i> : null}
                    </Link>
                  </div>
                </td>
                <td>
                  <div className="flex items-center">
                    {hotelGroup && hotelGroup.parentGroup ? (
                      <Link
                        className={"text-black"}
                        to={
                          isHotelGroupUser
                            ? ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_VIEW.replace(
                              ":id",
                              hotelGroup.id
                            )
                            : ROUTES.FRONTEND.HOTEL_GROUPS.SINGLE_VIEW.replace(
                              ":id",
                              hotelGroup?.parentGroup?.id
                            )
                        }
                      >
                        {hotelGroup?.parentGroup?.name}
                      </Link>
                    ) : (
                      "-"
                    )}
                  </div>
                </td>
                <td>
                  <div className="flex items-center">
                    {hotelGroup?.groupType && hotelGroup.groupType?.name}
                  </div>
                </td>
                <td className="px-6 py-3 whitespace-nowrap">
                  <div className="flex items-center justify-center">
                      <Link
                        to={ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_VIEW.replace(
                          ":id",
                          hotelGroup.id
                        )}
                        className={"text-black"}
                      >
                        <ButtonPrimary small>View</ButtonPrimary>
                      </Link>
                      {isHotelGroupAdmin || isRolePlatformAdmin ? (
                        <Link
                          to={ROUTES.FRONTEND.HOTEL_GROUPS_VENUE.SINGLE_EDIT.replace(
                            ":id",
                            hotelGroup.id
                          )}
                          className={"text-black"}
                        >
                          <ButtonPrimary  classes={'mx-2'} small>Edit</ButtonPrimary>
                        </Link>
                      ) : null}
                  </div>
                </td>
              </tr>
            );
          }
        )}
      </tbody>
    </table>
  );
};

export default HotelGroupsList;
